import type { ReactNode } from 'react';

const TableItemCard = ({
  title,
  main,
  onClick,
}: {
  title: ReactNode;
  main: ReactNode;
  onClick?: () => void;
}) => {
  const content = (
    <div className='eye:overflow-hidden eye:rounded-md eye:border eye:border-grey-20 eye:bg-white'>
      <div className='eye:truncate eye:bg-blue-25 eye:px-2xs eye:py-4xs eye:body-m-highlight eye:text-left'>
        {title}
      </div>

      <div className='eye:w-full eye:p-2xs'>{main}</div>
    </div>
  );

  if (onClick) {
    return (
      <button
        type='button'
        onClick={onClick}
        className='eye:w-full eye:cursor-pointer eye:rounded-md eye:focus-visible:outline-2 eye:hover:outline-2 eye:outline-black eye:outline-offset-3'
      >
        {content}
      </button>
    );
  }

  return content;
};

export default TableItemCard;
